import constantNavList from './constant-nav-list'
import constantTabList from './constant-tab-list'
import constantKeyValList from './constant-key-val-list'
import util from './util'

// 新核算单-销售表格子数据
const newTableSaleSubObj = {
  wu_liao_type: '', // 类型
  bind_id: '', // 绑定id
  list_fenl_lei_ids: [], // 类目ids
  list_fenl_lei_str: [], // 类目str
  seq: '', // 序号
  name: '', // 品名
  spec: '', // 规格
  unit: '', // 单位
  counts: '1', // 数量
  goods_price: '', // 产品单价
  goods_amount: '', // 产品金额
  jin_du: 0, // 进度
  bei_zhu: '', // 备注
  list_chan_pin_tu: [], // 产品图片
  list_gong_cheng_tu: [], // 工程图
  list_yuan_wen_jian: [], // 源文件
  list_jian_ce_mu_ban: [], // 检测模板
  list_jian_ce_bao_gao: [] // 检测报告
}

const constant = {
  // 菜单导航列表
  ...constantNavList,
  // 选项卡列表
  ...constantTabList,
  // 键值列表
  ...constantKeyValList,

  // 公司数据
  company_info: {
    company_name: '佛山市极速旺金属科技有限公司', // 公司名称
    company_address: '广东省佛山市顺德区北滘镇西滘工业区7号之21-2', // 公司地址
    company_phone: '0757-23305958' // 公司电话
  },

  // 分页
  page: {
    size: 'default',
    total: 0,
    currentPage: 1,
    pageSize: 50,
    pageSizes: [10, 20, 50, 100, 200, 500],
    layouts: [
      'Sizes',
      'PrevJump',
      'PrevPage',
      'Number',
      'NextPage',
      'NextJump',
      'FullJump',
      'Total'
    ]
  },
  pageMax: 999999,
  // 表格默认配置
  tableDefaultConfig: {
    loading: false,
    size: 'mini', // 尺寸
    border: true, // 边框
    minHeight: '', // 64
    // 配置-工具栏
    toolbarConfig: {
      enabled: false // 是否开启
    },
    // 配置-编辑
    editConfig: {
      trigger: 'click', // 单击
      mode: 'cell' // 单元格
    },
    // 配置-行
    rowConfig: {
      isHover: true, // 鼠标经过
      isCurrent: true, // 高亮
      useKey: true // 是否需要为每一列的 VNode 设置 key 属性
    },
    // 配置-鼠标
    mouseConfig: {
      selected: true // 设置选中单元格
    },
    // 配置键盘
    keyboardConfig: {
      enterToTab: true, // 是否将回车键行为改成 Tab 键行为
      isArrow: true, // 开启方向键功能
      isEnter: true, // 开启回车键功能
      isTab: true, // 开启Tab键功能
      isEdit: true // 开启任意键进入编辑（功能键除外）
    }
  },
  uploadFilePrompt: (limit = 5, fileSize, text) => {
    let result = text || `只能上传${limit}个文件，且每个不超过${fileSize}MB!`
    return result
  },
  uploadImagePrompt: (limit = 5, fileSize, fileType, text) => {
    let result =
      text || `只能上传${limit}个图片，类型为${fileType.join(',')}，且每个不超过${fileSize}MB!`
    return result
  },
  // 核算单-销售表格
  tableSaleObj: {
    wu_liao_code: '', // 物料号
    need_wu_liao_code: [], // 所需物料号
    wu_liao_cut_code: [], // 切管物料号
    category: '', // 品类
    craft: '', // 品名
    texture: '', // 材质
    sales_specification: '', // 规格
    counts_unit: '', // 每套零件数量
    counts: '', // 数量
    unit: '', // 单位
    cost_price_unit: '', // 每件材料成本
    process_price_unit: '', // 每件加工组装
    process_price: '', // 所需加工组装
    sales_price: '', // 销售单价
    sales_amount: '', // 销售金额
    profit_row_unit: '', // 每件利润
    profit_row: '', // 合计利润
    profit_rate: '', // 利润率
    photo_list: [], // 产品图片

    // 原材料计算
    material_length: '6000', // 原料长度 6000
    parts_length: '', // 零件长度 6000
    tailing_length: '', // 尾料长度
    today_base_price: '14', // 今日基价 14
    single_weight: '', // 支重
    material_price: '', // 材料单价
    is_lock_material_price: false, // 是否锁定材料单价
    parts_count: '', // 每支可切数量
    material_counts: '', // 所需材料数量
    is_lock_material_counts: false, // 是否锁定所需材料数量
    material_sales_amount: '', // 所需材料成本
    material_photo_list: [], // 图纸
    picture_text: '', // 附言
    test_list: [
      {
        test_name: '',
        test_action: '',
        test_rule: '',
        test_scale: '',
        reference_standard: '',
        remark: ''
      }
    ],

    // 加工组装计算
    process_list: [
      {
        wu_liao_code: '', // 物料号
        need_wu_liao_code: [], // 所需物料号
        process_order_name: '', // 工序
        process_name: '', // 加工工艺
        process_price: '', // 加工单价
        process_count: '', // 数量
        process_amount: '', // 加工金额
        picture_list: [], // 图纸
        picture_text: '', // 附言
        test_list: [
          {
            test_name: '',
            test_action: '',
            test_rule: '',
            test_scale: '',
            reference_standard: '',
            remark: ''
          }
        ] // 检测标准
      }
    ],

    tableBomData: [] // bom表数据列表
  },
  newTableSaleSubObj: util.deepCopy(newTableSaleSubObj),
  // 新核算单-销售表格
  newTableSaleObj: {
    ...util.deepCopy(newTableSaleSubObj),

    texture: '', // 材质
    counts_unit: '1', // 每套零件数量
    sales_price: '', // 含税销售单价
    sales_amount: '', // 含税销售金额
    wei_shui_sales_price: '', // 未税销售单价
    wei_shui_sales_amount: '', // 未税销售金额
    shuilv: '', // 税率
    shuie: '', // 税额
    profit_row_unit: '', // 每件利润
    profit_row: '', // 合计利润
    profit_rate: '', // 利润率

    // 原材料计算
    material_length: '6000', // 原料长度 6000
    parts_length: '', // 零件长度 6000
    tailing_length: '', // 尾料长度
    today_base_price: '14', // 今日基价 14
    single_weight: '', // 支重
    material_price: '', // 材料单价
    parts_count: '', // 每支可切数量
    material_counts: '', // 所需材料数量

    table_data_1: [{ ...util.deepCopy(newTableSaleSubObj), has_bom: false }],
    table_data_2: [],
    table_data_3: [],
    table_data_4: [],
    tableBomData: [] // bom表数据列表
  },
  // 核算单-加工表格
  tableProcessObj: {
    wu_liao_code: '', // 物料号
    need_wu_liao_code: [], // 所需物料号
    process_order_name: '', // 工序
    process_name: '', // 加工工艺
    process_price: '', // 加工单价
    process_count: '', // 数量
    process_amount: '', // 加工金额
    picture_list: [], // 图纸
    picture_text: '', // 附言
    test_list: [] // 检测标准
  },
  // 核算单-检测表格
  tableTestObj: {
    test_name: '', // 检测项目
    test_action: '', // 检测方法
    test_rule: '', // 检测标准
    test_scale: '', // 检测比例
    reference_standard: '', // 参考标准
    remark: '' // 备注
  },
  muBanShangPinDefaultData: {
    id: '',

    lei_mu_name: '', // 类目名称
    lei_mu_data: {}, // 类目数据
    lei_mu_lei_xing: '', // 类目类型
    dan_jia_lei_xing: '0', // 单价类型

    mu_ban_id: '', // 模板id
    mu_ban_ming_cheng: '', // 模板名称
    mu_ban_guan_jian_ci: '', // 模板关键词
    mu_ban_feng_mian: [], // 模板封面

    mi_du_shi_li: '', // 密度示例
    gui_ge_shi_li: '', // 规格示例
    gui_ge_list: [], // 规格

    can_shu_tu_pian: [], // 参数示图
    fu_jia_can_shu_list: [], // 附加参数
    fu_jia_can_shu_shi_li: [], // 附加参数示例

    mo_ren_dan_wei_zu: '', // 默认单位
    dan_wei_zu_list: [], // 单位

    ji_chu_chan_liang: '', // 基础产量
    ji_chu_chan_liang_list: [
      [
        {
          tiao_zheng_key_list: [], // 参数列表
          tiao_zheng_scope_start: '', // 参数范围-开始
          tiao_zheng_scope_end: '', // 参数范围-结束
          tiao_zheng_scope_val: '', // 参数范围-匹配值
          tiao_zheng_type: '', // 调整方式
          tiao_zheng_val: '' // 调整值
        }
      ],
      [
        {
          tiao_zheng_key_list: [], // 参数列表
          tiao_zheng_scope_start: '', // 参数范围-开始
          tiao_zheng_scope_end: '', // 参数范围-结束
          tiao_zheng_scope_val: '', // 参数范围-匹配值
          tiao_zheng_type: '', // 调整方式
          tiao_zheng_val: '' // 调整值
        }
      ]
    ], // 基础产量列表

    ji_chu_jia_ge: '', // 基础价格
    ji_chu_jia_ge_list: [
      [
        {
          tiao_zheng_key_list: [], // 参数列表
          tiao_zheng_scope_start: '', // 参数范围-开始
          tiao_zheng_scope_end: '', // 参数范围-结束
          tiao_zheng_scope_val: '', // 参数范围-匹配值
          tiao_zheng_type: '', // 调整方式
          tiao_zheng_val: '' // 调整值
        }
      ],
      [
        {
          tiao_zheng_key_list: [], // 参数列表
          tiao_zheng_scope_start: '', // 参数范围-开始
          tiao_zheng_scope_end: '', // 参数范围-结束
          tiao_zheng_scope_val: '', // 参数范围-匹配值
          tiao_zheng_type: '', // 调整方式
          tiao_zheng_val: '' // 调整值
        }
      ]
    ], // 基础价格列表

    she_bei_list: [], // 绑定设备列表

    custom_mo_kuai_list: [
      {
        name: '基础信息模块',
        list: [
          {
            is_show: true,
            is_edit: false,
            is_set: true,
            name: '商品信息',
            list: [
              {
                is_show: true, // 是否显示(二级/三级)
                is_edit: false, // 是否可编辑(二级/三级)
                is_set: false, // 是否可设置(二级/三级)
                name: '商品名称',
                zi_duan_ku_id: '',
                lei_xing_str: '输入框(文字)',
                lei_xing_id: 1
              },
              {
                is_show: true,
                is_edit: false,
                is_set: false,
                name: '商品关键词',
                zi_duan_ku_id: '',
                lei_xing_str: '输入框(分隔)',
                lei_xing_id: 4,
                set_symbol: ','
              },
              {
                is_show: true,
                is_edit: false,
                is_set: false,
                name: '商品编码',
                zi_duan_ku_id: '',
                lei_xing_str: '输入框(文字)',
                lei_xing_id: 1
              },
              {
                is_show: true,
                is_edit: false,
                is_set: false,
                name: '商品封面',
                zi_duan_ku_id: '',
                lei_xing_str: '上传(图片)',
                lei_xing_id: 10
              },
              {
                is_show: true,
                is_edit: false,
                is_set: false,
                name: '规格',
                zi_duan_ku_id: '',
                lei_xing_str: '输入框(分隔)',
                lei_xing_id: 4,
                set_symbol: '*'
              },
              {
                is_show: true,
                is_edit: false,
                is_set: false,
                name: '单位',
                zi_duan_ku_id: '',
                lei_xing_str: '下拉框',
                lei_xing_id: 8,
                set_options: [
                  {
                    key: '件',
                    val: '件'
                  },
                  {
                    key: '支',
                    val: '支'
                  },
                  {
                    key: '个',
                    val: '个'
                  },
                  {
                    key: '套',
                    val: '套'
                  },
                  {
                    key: '张',
                    val: '张'
                  }
                ]
              },
              {
                is_show: false,
                is_edit: false,
                is_set: false,
                name: '单件数量',
                zi_duan_ku_id: '',
                lei_xing_str: '输入框(数字)',
                lei_xing_id: 2
              },
              {
                is_show: true,
                is_edit: false,
                is_set: false,
                name: '数量',
                zi_duan_ku_id: '',
                lei_xing_str: '输入框(数字)',
                lei_xing_id: 2
              },
              {
                is_show: true,
                is_edit: false,
                is_set: false,
                name: '单价',
                zi_duan_ku_id: '',
                lei_xing_str: '公式',
                lei_xing_id: 11,
                set_gong_shi: ['材料单价', '+', '加工单价']
              },
              {
                is_show: false,
                is_edit: false,
                is_set: false,
                name: '单件金额',
                zi_duan_ku_id: '',
                lei_xing_str: '公式',
                lei_xing_id: 11,
                set_gong_shi: ['单价', '*', '单件数量']
              },
              {
                is_show: true,
                is_edit: false,
                is_set: false,
                name: '金额',
                zi_duan_ku_id: '',
                lei_xing_str: '公式',
                lei_xing_id: 11,
                set_gong_shi: ['单价', '*', '数量']
              }
            ]
          }
        ]
      }
    ], // 自定义模块列表
    default_mo_kuai_list: [
      {
        name: '所需物料',
        list: [
          {
            name: '商品名称'
          },
          {
            name: '规格'
          },
          {
            name: '单位'
          },
          {
            name: '单件数量'
          },
          {
            name: '单价'
          },
          {
            name: '单件金额'
          }
        ]
      },
      {
        name: '工艺路线',
        list: [
          {
            name: '模板名称'
          },
          {
            name: '规格'
          },
          {
            name: '单位'
          },
          {
            name: '单件数量'
          },
          {
            name: '单价'
          },
          {
            name: '单件金额'
          }
        ]
      }
    ] // 默认模块列表
  },
  // 商品模板规格列表
  shangPinMuBanGuiGeList: [
    {
      key: '外径',
      val: '外径'
    },
    {
      key: '内径',
      val: '内径'
    },
    {
      key: '直径',
      val: '直径'
    },
    {
      key: '边长',
      val: '边长'
    },
    {
      key: '边宽',
      val: '边宽'
    },
    {
      key: '长度',
      val: '长度'
    },
    {
      key: '宽度',
      val: '宽度'
    },
    {
      key: '高度',
      val: '高度'
    },
    {
      key: '厚度',
      val: '厚度'
    },
    {
      key: '长边宽',
      val: '长边宽'
    },
    {
      key: '短边宽',
      val: '短边宽'
    },
    {
      key: '长边厚',
      val: '长边厚'
    },
    {
      key: '短边厚',
      val: '短边厚'
    },
    {
      key: '对边距',
      val: '对边距'
    },
    {
      key: '腰高',
      val: '腰高'
    },
    {
      key: '腿宽',
      val: '腿宽'
    },
    {
      key: '腰厚',
      val: '腰厚'
    },
    {
      key: '腿厚',
      val: '腿厚'
    },
    {
      key: '重量(kg)',
      val: '重量(kg)'
    },
    {
      key: '卷数',
      val: '卷数'
    }
  ],
  // 商品模版单位列表-原料
  shangPinMuBanUnitListYuanLiao: [
    {
      dan_wei_zu_name: '公共单位',
      gong_shi_list: ['1'],
      dan_wei_list: [
        {
          dan_wei_name: '支',
          zhuan_huan_zhi: '1',
          is_zhu_ji_liang: true,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        }
      ]
    },
    {
      dan_wei_zu_name: '重量',
      gong_shi_list: [],
      dan_wei_list: [
        {
          dan_wei_name: 'kg',
          zhuan_huan_zhi: '1',
          is_zhu_ji_liang: true,
          is_mo_ren_dan_wei: true,
          verify_unit_val: ''
        },
        {
          dan_wei_name: 'g',
          zhuan_huan_zhi: '1000',
          is_zhu_ji_liang: false,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        },
        {
          dan_wei_name: 't',
          zhuan_huan_zhi: '0.001',
          is_zhu_ji_liang: false,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        }
      ]
    },
    {
      dan_wei_zu_name: '长度',
      gong_shi_list: [],
      dan_wei_list: [
        {
          dan_wei_name: 'mm',
          zhuan_huan_zhi: '1',
          is_zhu_ji_liang: true,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        },
        {
          dan_wei_name: 'cm',
          zhuan_huan_zhi: '0.1',
          is_zhu_ji_liang: false,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        },
        {
          dan_wei_name: 'm',
          zhuan_huan_zhi: '0.001',
          is_zhu_ji_liang: false,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        }
      ]
    },
    {
      dan_wei_zu_name: '表面积',
      gong_shi_list: [],
      dan_wei_list: [
        {
          dan_wei_name: 'mm²',
          zhuan_huan_zhi: '1',
          is_zhu_ji_liang: true,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        },
        {
          dan_wei_name: 'cm²',
          zhuan_huan_zhi: '0.01',
          is_zhu_ji_liang: false,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        },
        {
          dan_wei_name: 'm²',
          zhuan_huan_zhi: '0.000001',
          is_zhu_ji_liang: false,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        }
      ]
    },
    {
      dan_wei_zu_name: '体积',
      gong_shi_list: [],
      dan_wei_list: [
        {
          dan_wei_name: 'mm³',
          zhuan_huan_zhi: '1',
          is_zhu_ji_liang: true,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        },
        {
          dan_wei_name: 'cm³',
          zhuan_huan_zhi: '0.001',
          is_zhu_ji_liang: false,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        },
        {
          dan_wei_name: 'm³',
          zhuan_huan_zhi: '0.000000001',
          is_zhu_ji_liang: false,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        }
      ]
    }
  ],
  // 商品模版单位列表-组装
  shangPinMuBanUnitListZuZhuang: [
    {
      dan_wei_zu_name: '公共单位',
      gong_shi_list: ['1'],
      dan_wei_list: [
        {
          dan_wei_name: '件',
          zhuan_huan_zhi: '1',
          is_zhu_ji_liang: true,
          is_mo_ren_dan_wei: true,
          verify_unit_val: ''
        },
        {
          dan_wei_name: '支',
          zhuan_huan_zhi: '1',
          is_zhu_ji_liang: false,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        },
        {
          dan_wei_name: '个',
          zhuan_huan_zhi: '1',
          is_zhu_ji_liang: false,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        },
        {
          dan_wei_name: '套',
          zhuan_huan_zhi: '1',
          is_zhu_ji_liang: false,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        },
        {
          dan_wei_name: '张',
          zhuan_huan_zhi: '1',
          is_zhu_ji_liang: false,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        },
        {
          dan_wei_name: 'kg',
          zhuan_huan_zhi: '1',
          is_zhu_ji_liang: false,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        },
        {
          dan_wei_name: 'mm',
          zhuan_huan_zhi: '1',
          is_zhu_ji_liang: false,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        },
        {
          dan_wei_name: 'mm²',
          zhuan_huan_zhi: '1',
          is_zhu_ji_liang: false,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        },
        {
          dan_wei_name: 'mm³',
          zhuan_huan_zhi: '1',
          is_zhu_ji_liang: false,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        }
      ]
    }
  ],
  // 商品模版单位列表-原料引用
  shangPinMuBanUnitListImport: [
    {
      dan_wei_zu_name: '公共单位',
      gong_shi_list: ['1'],
      dan_wei_list: [
        {
          dan_wei_name: '支',
          zhuan_huan_zhi: '1',
          is_zhu_ji_liang: true,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        }
      ]
    },
    {
      dan_wei_zu_name: '重量',
      gong_shi_list: [
        '(',
        '外径',
        '-',
        '厚度',
        ')',
        '*',
        '厚度',
        '*',
        '密度',
        '*',
        '长度',
        '/',
        '1000'
      ],
      dan_wei_list: [
        {
          dan_wei_name: 'kg',
          zhuan_huan_zhi: '1',
          is_zhu_ji_liang: true,
          is_mo_ren_dan_wei: true,
          verify_unit_val: ''
        },
        {
          dan_wei_name: 'g',
          zhuan_huan_zhi: '1000',
          is_zhu_ji_liang: false,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        },
        {
          dan_wei_name: 't',
          zhuan_huan_zhi: '0.001',
          is_zhu_ji_liang: false,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        }
      ]
    },
    {
      dan_wei_zu_name: '长度',
      gong_shi_list: ['长度'],
      dan_wei_list: [
        {
          dan_wei_name: 'mm',
          zhuan_huan_zhi: '1',
          is_zhu_ji_liang: true,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        },
        {
          dan_wei_name: 'cm',
          zhuan_huan_zhi: '0.1',
          is_zhu_ji_liang: false,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        },
        {
          dan_wei_name: 'm',
          zhuan_huan_zhi: '0.001',
          is_zhu_ji_liang: false,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        }
      ]
    },
    {
      dan_wei_zu_name: '表面积',
      gong_shi_list: ['π', '*', '外径', '*', '长度'],
      dan_wei_list: [
        {
          dan_wei_name: 'mm²',
          zhuan_huan_zhi: '1',
          is_zhu_ji_liang: true,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        },
        {
          dan_wei_name: 'cm²',
          zhuan_huan_zhi: '0.01',
          is_zhu_ji_liang: false,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        },
        {
          dan_wei_name: 'm²',
          zhuan_huan_zhi: '0.000001',
          is_zhu_ji_liang: false,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        }
      ]
    },
    {
      dan_wei_zu_name: '体积',
      gong_shi_list: ['π', '*', '(', '外径', '/', '2', ')', '²', '*', '长度'],
      dan_wei_list: [
        {
          dan_wei_name: 'mm³',
          zhuan_huan_zhi: '1',
          is_zhu_ji_liang: true,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        },
        {
          dan_wei_name: 'cm³',
          zhuan_huan_zhi: '0.001',
          is_zhu_ji_liang: false,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        },
        {
          dan_wei_name: 'm³',
          zhuan_huan_zhi: '0.000000001',
          is_zhu_ji_liang: false,
          is_mo_ren_dan_wei: false,
          verify_unit_val: ''
        }
      ]
    }
  ],
  // 商品时间单位组
  shangPinShiJianUnitData: {
    dan_wei_zu_name: '时间',
    gong_shi_list: [],
    dan_wei_list: [
      {
        dan_wei_name: '时',
        zhuan_huan_zhi: '1',
        is_zhu_ji_liang: true,
        is_mo_ren_dan_wei: true,
        verify_unit_val: ''
      },
      {
        dan_wei_name: '分',
        zhuan_huan_zhi: '60',
        is_zhu_ji_liang: false,
        is_mo_ren_dan_wei: false,
        verify_unit_val: ''
      },
      {
        dan_wei_name: '秒',
        zhuan_huan_zhi: '3600',
        is_zhu_ji_liang: false,
        is_mo_ren_dan_wei: false,
        verify_unit_val: ''
      }
    ]
  },
  // 匹配字段分隔符号
  pipeiSymbolList: ['*', ',', '∗', '，']
}

export default constant
